/**
 * Core vocabulary shared by the API, the SPA, the Functions and the migration tooling.
 * Keep this file free of runtime dependencies; it is the contract every package compiles against.
 */
export const ENTITY_TYPES = ['customer', 'site', 'supplier'];
export const APP_ROLES = [
    'Credit.Analyst',
    'AR.Specialist',
    'Sales.Branch',
    'Purchasing',
    'Records.Admin',
    'Auditor',
];
export const ACTIONS = [
    'read',
    'upload',
    'download',
    'hide',
    'unhide',
    'remove',
    'archive',
    'grant',
    'hold',
    'audit',
];
export const DOCUMENT_STATUSES = [
    'uploading',
    'scanning',
    'available',
    'rejected',
    'hidden',
    'purged',
];
export const FOLDER_STATUSES = ['active', 'archived'];
//# sourceMappingURL=types.js.map